import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpService } from '../../../../../core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteLotDialogComponent } from './deleteLotDialog/deleteLotDialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Constants } from '../../../../../core/services/constants.service';
import { environment } from '../../../../../../environments/environment';
import { LinkPackageComponent } from './link-package/link-package.component';
import { MatCheckboxChange } from '@angular/material/checkbox';


@Component({
    selector: 'app-edit-lot',
    templateUrl: './edit-lot.component.html',
    styleUrls: ['./edit-lot.component.scss']
})

export class EditLotComponent implements OnInit {
    form: any;
    logoImageForm: FormGroup;

    isLogoTooLarge: boolean;
    hasLogo: boolean;
    logo = [];
    isLogoUploading: boolean;
    noLogoSelected: boolean;



    isSubmitted: any;

    lot: any;
    lotId: any;
    project: any;
    projectName: any;
    projectCode: any;
    projectId: any;

    SERVER_URL = environment.SERVER_URL;
    propertyPromotionTags = [];
    selectedTagIdArray = [];

    constructor(private fb: FormBuilder,
        private httpService: HttpService,
        private toastrService: ToastrService,
        private router: Router,
        private route: ActivatedRoute,
        private dialog: MatDialog) {
        this.form = this.fb.group({
            lotNumber: [''],
            lotSize: [''],
            width: [''],
            length: [''],
            price: [''],
            stage: [''],
            status: [''],
            parkFront: [''],
            lakeFront: [''],
            cornerBlock: [''],
        });

        this.logoImageForm = this.fb.group({
            logo: []
        });
    }

    ngOnInit(): void {
        this.lotId = parseInt(this.route.snapshot.paramMap.get('lotId'), 10);
        console.log(this.lotId);
        this.route.queryParams.subscribe(params => {
            console.log(params);
            this.projectCode = params.projectCode;
            this.projectName = params.projectName;
            this.projectId = params.projectId;
            this.project = window.history.state.project;
            console.log(this.project);
            this.httpService.getLotDetail(this.lotId).subscribe((res: any) => {
                console.log(res);
                if (res.code === 1) {
                    this.lot = res.data;
                    this.form.patchValue({
                        lotNumber: res.data.lotNumber,
                        lotSize: res.data.lotSize,
                        width: res.data.width,
                        length: res.data.length,
                        price: res.data.price,
                        stage: res.data.stage,
                        status: res.data.status,
                        parkFront: res.data.parkFront,
                        lakeFront: res.data.lakeFront,
                        cornerBlock: res.data.cornerBlock,
                    });
                }
            });

            this.httpService.getAllTagsByUser().subscribe((res: any) => {
                console.log(res);
                if (res.code === 1) {
                    this.propertyPromotionTags = res.data.filter(m => m.scope === 4 && m.type === 5);
                    if (this.lot.tags) {
                        this.lot.tags.map((tag) => {
                            this.selectedTagIdArray.push(tag.id);
                        });
                        // console.log(this.selectedTagIdArray);
                    }
                }
            });
        });

    }

    openDeleteLotDialog() {
        const dialogRef = this.dialog.open(DeleteLotDialogComponent, {
            width: '400px',
            disableClose: true,
            data: {
                lotId: this.lot.id
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result && result.result === 1) {
                this.router.navigateByUrl('/projects/' + this.projectId);
            }
        });
    }

    isCheckBoxSelected(productId: number) {
        return this.selectedTagIdArray.includes(productId);
    }

    select(event: MatCheckboxChange, productId) {
        console.log(this.selectedTagIdArray);
        if (event.checked) {
            this.selectedTagIdArray.push(productId);
            // if (this.selectedProductIdArray.length >= 2) {
            //     this.canCombine = true;
            // }
        } else {
            const index = this.selectedTagIdArray.indexOf(productId);
            this.selectedTagIdArray.splice(index, 1);
            // if (this.selectedProductIdArray.length < 2) {
            //     this.canCombine = false;
            // }
        }
        console.log(this.selectedTagIdArray);
    }

    updateLot() {
        this.isSubmitted = true;
        const fd = new FormData();
        fd.append('id', this.lotId);
        fd.append('lotNumber', this.form.get('lotNumber').value);
        fd.append('lotSize', this.form.get('lotSize').value);
        fd.append('width', this.form.get('width').value);
        fd.append('length', this.form.get('length').value);
        fd.append('price', this.form.get('price').value);
        // fd.append('stage', this.form.get('stage').value);
        // @ts-ignore
        fd.append('stage', 0);
        fd.append('status', this.form.get('status').value);
        if (this.form.get('parkFront').value || this.form.get('parkFront').value === 0) {
            fd.append('parkFront', this.form.get('parkFront').value);
        }
        if (this.form.get('lakeFront').value || this.form.get('lakeFront').value === 0) {
            fd.append('lakeFront', this.form.get('lakeFront').value);
        }
        if (this.form.get('cornerBlock').value || this.form.get('cornerBlock').value === 0) {
            fd.append('cornerBlock', this.form.get('cornerBlock').value);
        }

        if (this.selectedTagIdArray.length > 0) {
            fd.append('tagIds', this.selectedTagIdArray.toString());
        }

        this.httpService.updateLot(fd, this.lotId).subscribe((res: any) => {
            console.log(res);
            if (res.code === 1) {
                // this.uploadLotEvent.emit({newLot: res.data});
                // this.changeModeEvent.emit({value: 'manage'});

                // 统一跳转到 project 详情
                this.router.navigateByUrl('/projects/' + this.project.id);

                this.toastrService.success('One lot has been updated.');
            } else {
                this.toastrService.error('Failed to update lot.');
            }
        });
    }

    onLogoChange(event) {
        if (event.target.files && event.target.files[0]) {
            // const filesAmount = event.target.files.length;
            if (event.target.files[0].size > Constants.UPLOAD_IMAGE_SIZE) {
                this.isLogoTooLarge = true;
                return;
            } else {
                this.isLogoTooLarge = false;
                this.logo.push(event.target.files[0]);
            }
        }
    }

    uploadProjectLogo() {
        if (this.logo.length === 0) {
            this.noLogoSelected = true;
            return;
        }

        // if (this.lot.lotImage) {
        //     this.hasLogo = true;
        //     return;
        // }
        this.isLogoUploading = true;
        const fd = new FormData();
        fd.append('lotImage', this.logo[0]);
        this.httpService.updateLot(fd, this.lotId).subscribe((res: any) => {
            console.log(res);
            if (res.code === 1) {
                this.lot.lotImage = res.data.lotImage;
                this.logo = [];
                // this.projectService.projects = null;
                this.logoImageForm.reset();
                this.toastrService.success('Lot image has been uploaded.');
                this.isLogoUploading = false;
            } else {
                this.toastrService.error('Failed to upload lot image.');
                this.isLogoUploading = false;
            }
        });
    }

    openLinkPackage(lot) {
        console.log(lot);
        const dialogRef = this.dialog.open(LinkPackageComponent, {
            width: '80%',
            data: {
                lot,
                projectId: this.projectId,
                project:this.project
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result && result.packageProjects) {
                this.lot.packageProjects = result.packageProjects;
            }
        });
    }

    // transformAmount(element){
    //     console.log(element);
    //     // this.formattedAmount = this.currencyPipe.transform(this.formattedAmount, '$');
    //     //
    //     // element.target.value = this.formattedAmount;
    // }
}
